import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown/with-html";
import axios from "axios";
import Layout from "../components/Layout";
import ReactPlayer from "react-player/youtube"
import TechStackItem from './../components/TechStackItem';
import  LineIcon  from 'react-lineicons';

function ProjectDetails(props) {
  const [content, setContent] = useState("");
  const [details, setDetails] = useState(null);
  const projectId = props.match.params.id;
  const fileName = props.match.params.title;

  useEffect(() => {
    axios
      .get(require(`../projects/${fileName}`))
      .then(result => {
        setContent(result.data);
      })
  }, [content, fileName]);

  useEffect(() => {
    let mounted = true;
    axios.get("/api/portfolios").then((response) => {
      if(mounted){
        const dets = response.data.find(project => project.id == projectId);
        setDetails(dets);
      }
    });
    return () => mounted = false;
  }, [details]);
  var player;
  const ref = p => {
    player = p
  }

  return (
    <Layout>
      <div className="mi-blog-details mi-section mi-padding-top mi-padding-bottom">
        <div className="container">
          <h1>
            {details && details.title} &nbsp; &nbsp; &nbsp; 
            {details && details.links.map(link => 
              <a rel="noopener noreferrer" target="_blank" href={link.url}>
                  <LineIcon name={link.icon}/>&nbsp; &nbsp;
              </a>) 
            }
          </h1>
          <p>{details && details.subtitle}</p>
          <h3>Tech Stack</h3>
          <div className="mi-tech-stack">
              {details && details.stack.map(tech => <TechStackItem content={tech}/>)}
          </div>
          {details && details['videoURL'] && <div style={{marginBottom: "24px"}}>
             <h3>Video</h3>
             <ReactPlayer
              ref={ref} 
              url={details.videoURL}
              controls
              onReady={() => {
                if(details['videoSeek']) {
                    player.seekTo(100)
                }
              }}
             />
           </div>}
          <ReactMarkdown source={content} escapeHtml={false}></ReactMarkdown>
        </div>
      </div>
    </Layout>
  );
}

export default ProjectDetails;
